import classnames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
//import { Select as AntSelect } from 'antd';
import AntSelect from 'antd/es/select';
import { generateUniqueKey } from 'lib/helpers';

import './Select.scss';

const refKey = generateUniqueKey( 5 );

/**
 * Select.
 */
const propTypes = {

}
const Select = React.memo( React.forwardRef( ( { customClassName, style, ...p }, ref ) => {

  // Find largest option in order to auToset select width.
  // if( ! p.children || typeof p.children !== 'array' ) {
  //   return <></>
  // }

  let maxChars = 0;

  p.children.map( option => {

    const text = option.props.children;

    if( text.length > maxChars ) {
      maxChars = text.length;
    }

  } );


  /* ------ = Output. = --------------------------------------------------------------------- */


  const className = classnames( 'Select', customClassName, {
    [`is-${p.type}`]: !! p.type,
  }
  );

  return(

    <AntSelect
    ref={ ref }
    className={ className }
    style={ {
      width: maxChars * 16,
      ...style,
    } }
    { ...p }
    dropdownAlign={{ offset:[0,0] }}
    >
      { p.children }
    </AntSelect>

  )

} ) );
Select.propTypes = propTypes;
Select.Option = AntSelect.Option;
Select.OptGroup = AntSelect.OptGroup;

export default Select;
